<template>
  <div :style="embedThemeStyles">
    <v-app id="inspire">
      <v-navigation-drawer
        dark
        v-model="drawer"
        width="290"
        app
        fixed
        :style="sidebarStyles"
      >
        <div
          style="
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          "
        >
          <div>
            <template v-if="isEmbedSession">
              <div class="embed-brand">
                <v-img
                  v-if="embedBranding.logoUrl"
                  :src="embedBranding.logoUrl"
                  :alt="embedBranding.name"
                  contain
                  max-height="90"
                />
                <div v-else class="embed-brand__name">
                  {{ embedBranding.name }}
                </div>
                <div class="embed-brand__powered">
                  <span>Powered by</span>
                  <v-img
                    :src="require('../assets/logos/Logotipo_Negativo.png')"
                    alt="Fresher"
                    contain
                    max-width="105"
                    max-height="34"
                  />
                </div>
              </div>
            </template>
            <v-list-item v-else title="My Application" subtitle="Vuetify" :to="'/products'" link>
              <v-img
                class="my-15"
                :src="require('../assets/logos/Logotipo_Negativo.png')"
                alt="Fresher"
              />
            </v-list-item>
            <v-divider></v-divider>
            <v-list class="mx-5 sidebar-menu">
              <div
                v-for="module in visibleSidebarModules"
                :key="module.key"
                class="sidebar-module"
              >
                <button
                  class="sidebar-module__header"
                  type="button"
                  @click="toggleSidebarModule(module.key)"
                >
                  <span class="sidebar-module__title">
                    <v-icon size="23" color="#ffffff">{{ module.icon }}</v-icon>
                    <span>{{ module.title }}</span>
                  </span>
                  <span class="sidebar-module__actions">
                    <span v-if="module.badge" class="sidebar-module__badge">
                      {{ module.badge }}
                    </span>
                    <v-icon size="22" color="#ffffff">
                      {{ openSidebarModules[module.key] ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                  </span>
                </button>

                <v-expand-transition>
                  <div v-show="openSidebarModules[module.key]" class="sidebar-module__body">
                    <template v-for="item in module.items">
                      <div
                        v-if="item.items"
                        :key="`${module.key}-${item.key}`"
                        class="sidebar-submodule"
                      >
                        <button
                          class="sidebar-submodule__header"
                          type="button"
                          @click="toggleSidebarGroup(module.key, item.key)"
                        >
                          <span class="sidebar-submodule__title">
                            <v-icon
                              v-if="item.icon"
                              size="20"
                              color="rgba(255, 255, 255, 0.82)"
                            >
                              {{ item.icon }}
                            </v-icon>
                            <span>{{ item.title }}</span>
                          </span>
                          <v-icon size="20" color="rgba(255, 255, 255, 0.82)">
                            {{ activeSidebarGroups[module.key] === item.key ? "mdi-chevron-up" : "mdi-chevron-down" }}
                          </v-icon>
                        </button>

                        <v-expand-transition>
                          <div
                            v-show="activeSidebarGroups[module.key] === item.key"
                            class="sidebar-submodule__items"
                          >
                            <v-list-item
                              v-for="child in item.items"
                              :key="`${module.key}-${item.key}-${child.value}`"
                              link
                              active-class="activeItem"
                              :to="child.path"
                              class="sidebar-menu-item sidebar-menu-item--nested"
                            >
                              <v-list-item-icon>
                                <v-icon size="19" color="rgba(255, 255, 255, 0.72)">
                                  {{ child.icon }}
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{ child.title }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-expand-transition>
                      </div>

                      <v-list-item
                        v-else
                        :key="`${module.key}-${item.value}`"
                        link
                        active-class="activeItem"
                        :to="item.path"
                        class="sidebar-menu-item"
                      >
                        <v-list-item-icon>
                          <v-icon size="21" color="rgba(255, 255, 255, 0.82)">
                            {{ item.icon }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </div>
                </v-expand-transition>
              </div>

            </v-list>
            <!-- <v-list class="mx-5">   
              <v-list-group
                v-for="item in filteredSections"
                :key="item.title"
                v-model="item.active"
                active-class="activeGroup"
                :prepend-icon="item.icon"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title style="word-wrap: normal;">{{
                      texts.menu[item.value]
                    }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="child in item.items"
                  link
                  active-class="activeItem"
                  :to="child.path"
                  :key="child.title"
                  :disabled="child.disabled"
                >
                  <v-list-item-content>
                    <v-list-item-title style="word-wrap: normal;">{{
                      texts.subMenu[child.value]
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list> -->
            <v-divider></v-divider>
          </div>
          <div>
            <v-divider></v-divider>
            <div class="pa-9">
              <div>
                <v-btn
                  @click="
                    changeLanguage('en');
                    $store.commit('setFadeMenu', false);
                  "
                  :class="
                    selectLanguage == 'en'
                      ? 'mon-medium button-select-language-active mb-2'
                      : 'mon-medium button-select-language mb-2'
                  "
                  elevation="0"
                >
                  <img class="mr-2" src="@/assets/images/US.svg" alt="" />
                  English
                </v-btn>
              </div>
              <div>
                <v-btn
                  @click="
                    changeLanguage('sp');
                    $store.commit('setFadeMenu', false);
                  "
                  :class="
                    selectLanguage == 'sp'
                      ? 'mon-medium button-select-language-active mt-2'
                      : 'mon-medium button-select-language mt-2'
                  "
                  elevation="0"
                >
                  <img class="mr-2" src="@/assets/images/MX.svg" alt="" />
                  Español
                </v-btn>
              </div>
            </div>
            <v-divider></v-divider>
            <div class="">
              <v-btn
                text
                class="button-session mon-regular px-0"
                @click="logout"
                style="font-family: 'montserrat-semibold'; justify-content: center"
              >
                <v-icon class="mr-2"> mdi-logout </v-icon>
                {{ texts.dashboard.logout }}
              </v-btn>
              <h5
                style="
                  font-family: 'montserrat-regular';
                  color: #ffffff;
                  font-size: 14px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                {{ texts.dashboard.version }} {{ appVersion }} | {{ currentYear }} ©
                FRESHER
              </h5>
              <h5
                class="pb-3"
                style="
                  font-family: 'montserrat-regular';
                  color: #ffffff;
                  font-size: 14px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                {{ texts.dashboard.allRightsReserved }}
              </h5>
            </div>
          </div>
        </div>
      </v-navigation-drawer>
      <v-app-bar color="#ffffff" absolute app height="83" style="z-index: 10; margin-left: 16px; margin-top: 8px; margin-right: 10px; border-radius: 25px; box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);" persistent>
        <v-btn
          icon
          dark
          class="d-lg-none d-block"
          @click="drawer = true"
        >
          <v-icon
            size="18px"
            color="#000000"
          >
            mdi-menu
          </v-icon>
        </v-btn>
        <v-toolbar-title
          style="
            font-size: 0.875rem;
            line-height: 1.25rem;
            font-weight: 600;
            display: flex;
            align-items: center;
          "
          class="pa-0"
        >
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ currentDateCdmx }} Ciudad de México, GMT-6
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon dark large color="grey"> mdi-account-circle </v-icon>
        <v-list width="170px">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ userName }}</v-list-item-title>
              <v-list-item-subtitle>{{ "Administrador" }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-app-bar>
      <v-main style="background-color: #f9fafd; overflow-y: scroll; scroll-behavior: smooth; height: calc(100vh - 83px);">
        <router-view></router-view>
        <v-dialog v-model="showTerms" persistent max-width="600">
          <v-card>
            <div class="d-flex align-center justify-space-between flex-wrap px-4 pt-4 mb-4">
              <v-card-title class="pa-0" style="font-family: 'montserrat-bold';">
                {{ termsDialogTitle }}
              </v-card-title>

              <v-btn-toggle
                :value="selectLanguage"
                mandatory
                dense
                class="mt-2 mt-sm-0"
                @change="changeTermsLanguage"
              >
                <v-btn value="en" small>
                  EN
                </v-btn>
                <v-btn value="sp" small>
                  ES
                </v-btn>
              </v-btn-toggle>
            </div>

            <v-card-text>
              <div class="mb-6" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 40px"></div>
                <div style="display: flex; flex-direction: column;">
                  <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E;">
                    {{ termsDialogMessage }}
                  </div>
                </div>
              </div>

              <v-sheet
                style="font-family: 'montserrat-bold'; border-radius: 10px; box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px; border: thin solid rgba(0, 0, 0, 0.120); background-color: #f9fafd !important;"
                height="290"
                class="overflow-y-auto px-3 py-2 grey lighten-4"
              >
                <div v-html="termsHtml" style="line-height: normal;"></div>
              </v-sheet>

              <v-checkbox
                v-model="accepted"
                style="font-family: 'montserrat-bold';"
                :label="termsAcceptLabel"
                class="mt-4"
              />

              <v-card-actions style="justify-content: space-evenly;">
                <v-btn
                  elevation="4"
                  class="mr-2 px-10"
                  style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="logout()"
                >
                  {{ texts.modalForm.cancel }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="4343"
                  class="white--text px-10"
                  style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                  :disabled="!accepted"
                  @click="acceptTerms()"
                > 
                  {{ texts.modalForm.confirm }}
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import moment from "moment";
import { aiAccess, refreshAiAccess } from '@/services/aiAccess';

export default {
  name: "DashboardView",
  data() {
    return {
      texts: "",
      loading: true,
      currentDate: moment(),
      currentDateCdmx: moment().clone().utcOffset("-06:00"),
      drawer: null,
      balance: "0",
      appVersion: "1.0.01",
      currentYear: moment().format("YYYY"),
      items: [],
      isDivisasOpen: false,
      isOperacionesOpen: false,
      isAiMenuOpen: false,
      openSidebarModules: {
        currency: false,
        factoring: false,
        aiAgents: false,
        settings: false,
      },
      activeSidebarGroups: {
        currency: "",
      },
      availableIds: [],
      // sections: [
      //   { icon: "mdi mdi-view-dashboard", value: "operation", title: "Operaciones",
      //     items: [
      //       { id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a', icon: "mdi mdi-view-dashboard", value: "dashboard", title: "Dashboard", path: "/dashboard", disabled: false},
      //       { id: '93a6a75e-19cc-4274-9c67-87913ef9e7f7', icon: "mdi-file-document", value: "history", title: "Seguimiento de facturas", path: "/invoices", disabled: false },
      //       { id: '00e2b5da-6e63-4984-ab1d-b16de53f6324', icon: "mdi-forward", value: "activeForwards", title: "Forwards activos", path: "/forwards", disabled: false },
      //       { id: '7fecb47b-25fd-4c10-8523-93b62ef4cbe4', icon: "mdi-file-document", value: "history", title: "Seguimiento de facturas", path: "/invoicesReceivable", disabled: false },
      //       { id: '54a68c7a-402b-444b-8236-2b90105fd480', icon: "mdi-forward", value: "activeForwardsMX", title: "Forwards activos", path: "/forwardsMX", disabled: false },
      //       { id: '785e4626-c4a9-4026-a2ba-fa5313f895c9', icon: "mdi-cash", value: "balance", title: "Saldo disponible MXN", path: "/balance", disabled: false },
      //       { id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a', icon: "mdi-calendar", value: "calendar", title: "Calendar", path: "/calendars", disabled: false },
      //     ],
      //   },
      //   { icon: "mdi-history", value: "history", title: "Historial",
      //     items: [
      //       { id: 'e4bf603f-88a9-4e4c-84f5-d4fe5304aca2', icon: "mdi-file-document", value: "historyIn", title: "Historial de ingresos", path: "/incomes", disabled: false },
      //       { id: 'a29b2ef5-0b57-40f2-9782-455f323201f3', icon: "mdi-file-document", value: "historyConversion", title: "Historial de conversiones", path: "/conversions", disabled: false },
      //       { id: 'e4bc1bf5-f6ea-42be-9309-19a9c6bc6aba', icon: "mdi-file-document", value: "historyOut", title: "Historial de egresos", path: "/payments", disabled: false },
      //       { id: '5f9ee0eb-8e3c-43ea-a7f8-55815d1baafb', icon: "mdi-file-document", value: "historyConversionMX", title: "Historial conversiones ", path: "/conversionsMX", disabled: false },
      //       { id: 'ee6a1a81-3975-4a94-86c2-3c021ff63857', icon: "mdi-file-document", value: "historyOut", title: "Historial egresos", path: "/paymentsMX", disabled: false },
      //       { id: '800fe54b-3815-47a0-abdc-416ede7379df', icon: "mdi-note-text-outline", value: "statement", title: "Estado de cuenta", path: "/statement", disabled: false },
      //     ],
      //   },
      //   { icon: "mdi-wallet", value: "wallets", title: "Wallets",
      //     items: [
      //       { id: '72318c2b-dad2-440c-8238-26f953a3e289', icon: "mdi-account-group", value: "clients", title: "Clientes", path: "/clients", disabled: false },
      //       { id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff', icon: "mdi-account-group", value: "suppliers", title: "Proveedores", path: "/suppliers", disabled: false },
      //     ],
      //   },
      //   { icon: "mdi-wallet", value: "financiamiento", title: "Financiamiento",
      //     items: [
      //       { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-account-group", value: "contracts", title: "Clientes", path: "/clientesFinancieroDeudor", disabled: false },
      //       { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-account-group", value: "invoices", title: "Invoices", path: "/financingInvoices", disabled: false },
      //       { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-account-group", value: "payments", title: "Payments", path: "/financePayment", disabled: false },
      //       // { id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff', icon: "mdi-account-group", value: "calendarTraditional", title: "Proveedores", path: "/calendar", disabled: false },
      //     ],
      //   },
      //   { icon: "mdi-wallet", value: "financiamiento", title: "Financiamiento",
      //     items: [
      //       { id: 'b5c838b1-4797-4296-903d-e08d6e9c4389', icon: "mdi-account-group", value: "contracts", title: "Clientes", path: "/clientesFinanciero", disabled: false },
      //       { id: 'b5c838b1-4797-4296-903d-e08d6e9c4389', icon: "mdi-account-group", value: "invoices", title: "Invoices", path: "/financingInvoicesAssignor", disabled: false },
      //       { id: 'b5c838b1-4797-4296-903d-e08d6e9c4389', icon: "mdi-account-group", value: "collection", title: "Collection", path: "/collectionHistory", disabled: false },
      //       // { id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff', icon: "mdi-account-group", value: "calendarTraditional", title: "Proveedores", path: "/calendarAssignor", disabled: false },
      //     ],
      //   },
      //   { icon: "mdi-cog", value: "settings", title: "Ajustes",
      //     items: [
      //       { id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a', icon: "mdi-shield-account", value: "security", title: "Seguridad", path: "/security", disabled: false },
      //     ],
      //   },
      // ],
      securityAgentMenu: [
        { id: '182f53b8-0056-47aa-9638-a52f1f13cf78', icon: "mdi-view-dashboard", value: "dashboard", title: "Consultar", path: "/securityAgent", disabled: false},
        { id: '182f53b8-0056-47aa-9638-a52f1f13cf78', icon: "mdi-file-document", value: "invoices", title: "Historial", path: "/reports", disabled: false }
      ],
      aiAgentMenu: [
        { icon: "mdi-rocket-launch", value: "start", title: "Start", path: "/ia-agents" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-view-dashboard-outline", value: "dashboard", title: "Dashboard", path: "/dashboardAI" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-phone-outline", value: "collectionAgent", title: "Agente de Cobranza", path: "/collectionAgent" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-bullhorn-outline", value: "leadsAgent", title: "Agente de Ventas", path: "/leadsAgent" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-shield-outline", value: "identityValidation", title: "Validación de Identidad", path: "/dueDiligence" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-chart-line-variant", value: "pricingIntelligence", title: "Inteligencia de Precios", path: "/priceIntelligence" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-credit-card-outline", value: "billing", title: "Billing & Suscripciones", path: "/bills" },
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-circle-multiple-outline", value: "credits", title: "Créditos", path: "/credits" },
      ],
      creditLineMenu: [
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-account-group", value: "contracts", title: "Linea de Crédito", path: "/creditLine", disabled: false },
      ],
      revolvingCreditMenu: [
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-account-group", value: "contracts", title: "Revolvente", path: "/revolvingCredit", disabled: false },
      ],
      fresherCargoMenu: [
        { id: 'a4cf99f2-34db-4c4a-b7ff-3b718c02f84d', icon: "mdi-truck-fast-outline", value: "fresherCargo", title: "Mi línea Cargo", path: "/fresherCargo", disabled: false },
      ],
      payFlexMenu: [
        { id: '770591ca-8088-49f1-a460-5fb4c4a2ad1d', icon: "mdi-cash-multiple", value: "payflex", title: "PayFlex", path: "/payflex", disabled: false },
      ],
      operationMenu: [
        { id: 'b4f3e431-6e6f-4375-a49f-d2349ef2db1a', icon: "mdi-view-dashboard", value: "dashboard", title: "Dashboard", path: "/dashboard", disabled: false},
        { id: '93a6a75e-19cc-4274-9c67-87913ef9e7f7', icon: "mdi-file-document", value: "invoices", title: "Seguimiento de facturas", path: "/invoices", disabled: false },
        { id: '00e2b5da-6e63-4984-ab1d-b16de53f6324', icon: "mdi-forward", value: "activeForwards", title: "Forwards activos", path: "/forwards", disabled: false },
        { id: '7fecb47b-25fd-4c10-8523-93b62ef4cbe4', icon: "mdi-file-document", value: "invoicesReceivable", title: "Seguimiento de facturas C", path: "/invoicesReceivable", disabled: false },
        { id: '54a68c7a-402b-444b-8236-2b90105fd480', icon: "mdi-forward", value: "activeForwardsMX", title: "Forwards activos", path: "/forwardsMX", disabled: false },
        { id: '785e4626-c4a9-4026-a2ba-fa5313f895c9', icon: "mdi-cash", value: "balance", title: "Saldo disponible MXN", path: "/balance", disabled: false },
        // { id: '770591ca-8088-49f1-a460-5fb4c4a2ad1d', icon: "mdi-cash", value: "pagosProgramados", title: "Pagos programados", path: "/pagosProgramados", disabled: false },
        // { id: '770591ca-8088-49f1-a460-5fb4c4a2ad1d', icon: "mdi-calendar", value: "calendar", title: "Calendar", path: "/calendars", disabled: false },
      ],
      historyMenu: [
        { id: 'e4bf603f-88a9-4e4c-84f5-d4fe5304aca2', icon: "mdi-file-document", value: "historyIn", title: "Historial de ingresos", path: "/incomes", disabled: false },
        { id: 'a29b2ef5-0b57-40f2-9782-455f323201f3', icon: "mdi-file-document", value: "historyConversion", title: "Historial de conversiones", path: "/conversions", disabled: false },
        { id: 'e4bc1bf5-f6ea-42be-9309-19a9c6bc6aba', icon: "mdi-file-document", value: "historyOut", title: "Historial de egresos", path: "/payments", disabled: false },
        // { id: '5f9ee0eb-8e3c-43ea-a7f8-55815d1baafb', icon: "mdi-file-document", value: "historyConversionMX", title: "Historial conversiones ", path: "/conversionsMX", disabled: false },
        // { id: 'ee6a1a81-3975-4a94-86c2-3c021ff63857', icon: "mdi-file-document", value: "historyOut", title: "Historial egresos", path: "/paymentsMX", disabled: false },
        { id: '800fe54b-3815-47a0-abdc-416ede7379df', icon: "mdi-note-text-outline", value: "statement", title: "Estado de cuenta", path: "/statement", disabled: false },
      ],
      contactsMenu: [
        { id: '72318c2b-dad2-440c-8238-26f953a3e289', icon: "mdi-account-group", value: "clients", title: "Clientes", path: "/clients", disabled: false },
        { id: '4b04b8b3-0a98-4ac4-9157-eb61e0f2b3ff', icon: "mdi-account-group", value: "suppliers", title: "Beneficiarios", path: "/suppliers", disabled: false },
      ],
      userName: "",
      tab: 0,
      editableData: {},
      selectedMenuItem: "",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY",
      },
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      timerCount: 30,
      sTypeAccount: "",
      accepted: false,
      termsAccepted: false,
      showTerms: false,
      termsHtml: "",
      termsContent: {},
      termsId: null,
      isLoadingTerms: false,
    };
  },
  created() {
  },
  methods: {
    hasMenuItemAccess(item) {
      return !item.id || this.availableIds.includes(item.id);
    },
    filterSidebarItems(items) {
      return items
        .map((item) => {
          if (item.items) {
            const filteredItems = this.filterSidebarItems(item.items);

            if (!filteredItems.length && !item.alwaysVisible) {
              return null;
            }

            return { ...item, items: filteredItems };
          }

          return this.hasMenuItemAccess(item) ? item : null;
        })
        .filter(Boolean);
    },
    filterSidebarModuleItems(items) {
      const filteredItems = this.filterSidebarItems(items);
      const hasAvailableMenuItems = filteredItems.some((item) => !item.fallbackOnly);

      if (!hasAvailableMenuItems) {
        return filteredItems;
      }

      return filteredItems.filter((item) => !item.fallbackOnly);
    },
    toggleSidebarModule(moduleKey) {
      this.$set(
        this.openSidebarModules,
        moduleKey,
        !this.openSidebarModules[moduleKey]
      );
    },
    toggleSidebarGroup(moduleKey, groupKey) {
      this.$set(
        this.activeSidebarGroups,
        moduleKey,
        this.activeSidebarGroups[moduleKey] === groupKey ? "" : groupKey
      );
    },
    updateTime() {
      this.currentDate = moment();
      this.currentDateCdmx = moment().utcOffset("-06:00");
    },
    logout: function () {
      if (this.$store.state.sToken !== "") {
        const isEmbedSession = this.$store.state.bEmbedSession;
        const embedSlug = this.$store.state.embedIntegrationSlug;
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
          },
        };

        DB.delete(`${URI}/api/v1/${this.selectLanguage}/session`, config)
          .then((response) => {
            const self = this;

            localStorage.clear();
            this.$store.commit("setIsLogged", false);
            this.$store.commit("setFadeMenu", false);
            this.$store.commit("setToken", "");
            this.$store.commit("setFullName", "");
            this.$store.commit("setEnterpriseId", "");
            this.$store.commit("setUserId", "");

            setTimeout(function () {
              self.mixSuccess(response.data.message);
            }, 200);

            const loginDestination =
              isEmbedSession && embedSlug
                ? {
                    name: "EmbedLogin",
                    params: { slug: embedSlug },
                  }
                : { path: "/login" };

            self.$router
              .replace(loginDestination)
              .catch(() => {})
              .finally(() => {
                self.$store.commit("setEmbedSession", false);
              });
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      }
    },
    changeLanguage(language) {
      const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
          },
        },
        payload = {};

      if (this.$store.state.sUserId) {
        DB.patch(
          `${URI}/api/v1/${language}/users/${this.$store.state.sUserId}/languages`,
          payload,
          config
        )
          .then((response) => {
            // Manejo de respuesta exitosa
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      }
      this.$store.commit("toggle_language", language);
    },
    changeTermsLanguage(language) {
      if (!language || language === this.selectLanguage) return;

      this.accepted = false;
      this.changeLanguage(language);

      this.$nextTick(() => {
        this.setTermsHtml();
      });
    },
    setTermsHtml() {
      const lang = this.selectLanguage || "en";

      this.termsHtml =
        this.termsContent?.[lang]?.html ||
        this.termsContent?.en?.html ||
        "";
    },
    checkUserTerms() {
      this.isLoadingTerms = true;

      DB.get(`${URI}/api/v1/${this.selectLanguage}/user-terms/status`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((res) => {
          if (!res.data.accepted && !res.data.error) {
            this.getLatestTerms();
          } else {
            this.termsAccepted = true;
            this.isLoadingTerms = false;
          }
        })
        .catch((error) => {
          this.isLoadingTerms = false;

        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
          // this.mixError(error.response.data.message, error.response.status);
        });
    },
    getLatestTerms() {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/terms/latest`)
        .then((res) => {
          this.termsContent = res.data.content || {};
          this.setTermsHtml();
          this.termsId = res.data.id;
          this.showTerms = true;
          this.isLoadingTerms = false;
        })
        .catch((error) => {
          this.isLoadingTerms = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    acceptTerms() {
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/user-terms/accept`,
        { termsId: this.termsId },
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        }
      )
        .then(() => {
          this.termsAccepted = true;
          this.showTerms = false;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    }
  },
  beforeMount() {
    this.checkUserTerms();
    this.interval = setInterval(this.updateTime, 1000); // 1000 ms = 1 segundo
    this.texts = { ...FILE.takeRate[this.selectLanguage], menu: FILE.menu[this.selectLanguage].menu };
    this.userName = this.$store.state.sFullName;
    this.availableIds = this.$store.state.sModules.map(mod => mod.sModuleId);
  },
  mounted() {
    refreshAiAccess();
    this.currentTime = this.currentDate.format("MMMM DD, YYYY, HH:mm:ss [GMT]Z");
    this.currentTimeCdmx = this.currentDateCdmx.format("MMMM DD, YYYY, HH:mm:ss [GMT-6]");
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    isEmbedSession() {
      return this.$store.state.bEmbedSession;
    },
    embedBranding() {
      return this.$store.state.embedBranding;
    },
    sidebarStyles() {
      return {
        backgroundColor: this.isEmbedSession
          ? this.embedBranding.primaryColor
          : "#193d6e",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        zIndex: 11,
      };
    },
    embedThemeStyles() {
      return {
        "--embed-primary-color": this.isEmbedSession
          ? this.embedBranding.primaryColor || "#193D6E"
          : "#193D6E",
        "--embed-accent-color": this.isEmbedSession
          ? this.embedBranding.accentColor || "#1976D2"
          : "#0075B8",
      };
    },
    selectLanguage: function () {
      return this.$store.state.language;
    },
    visibleSidebarModules() {
      const modules = [
        {
          key: "currency",
          title: "Divisas",
          icon: "mdi-cash",
          items: [
            {
              icon: "mdi-clipboard-text-outline",
              value: "onboarding",
              title: "Onboarding",
              path: "/requirements",
              fallbackOnly: true,
            },
            {
              key: "operations",
              title: "Operaciones",
              items: this.operationMenu,
            },
            {
              key: "history",
              title: "History",
              items: this.historyMenu,
            },
            {
              key: "contacts",
              title: "Contacts",
              items: this.contactsMenu,
            },
          ],
        },
        {
          key: "factoring",
          title: "Financiamiento",
          icon: "mdi-account-cash",
          badge: "¡Nuevo!",
          items: [
            {
              icon: "mdi-clipboard-text-outline",
              value: "factoringOnboarding",
              title: "Onboarding",
              path: "/requirements",
              fallbackOnly: true,
            },
            {
              key: "revolvingCredit",
              title: "Crédito Revolvente",
              items: this.revolvingCreditMenu,
            },
            {
              key: "fresherCargo",
              title: "Fresher Cargo Advance",
              items: this.fresherCargoMenu,
            },
            {
              key: "creditLine",
              title: "Linea de Crédito",
              items: this.creditLineMenu,
            },
          ],
        },
        {
          key: "aiAgents",
          title: "Fresher AI",
          icon: "mdi-auto-fix",
          badge: "New",
          items: aiAccess.allowed ? [
            { icon: 'mdi-view-dashboard-outline', title: 'Dashboard', value: 'dashboard', path: '/dashboardAI' },
            { icon: 'mdi-shield-outline', title: 'Agente de Riesgo', value: 'risk', path: '/dueDiligence' },
            { icon: 'mdi-credit-card-outline', title: 'Billing & Suscripciones', value: 'billing', path: '/bills' },
            { icon: 'mdi-circle-multiple-outline', title: 'Créditos', value: 'credits', path: '/credits' },
          ] : [{ icon: 'mdi-rocket-launch', title: 'Start', value: 'start', path: '/ia-agents' }],
        },
        {
          key: "PayFlex",
          title: "PayFlex",
          icon: "mdi-cash-multiple",
          items: this.payFlexMenu,
        },
        {
          key: "settings",
          title: "Settings",
          icon: "mdi-cog",
          items: [
            {
              icon: "mdi-shield-account-outline",
              value: "security",
              title: "Security",
              path: "/security",
            },
          ],
        },
      ];

      const currencyModule = modules.find(module => module.key === "currency");

      if (this.isEmbedSession) {
        const embedIcons = {
          operations: "mdi-swap-horizontal",
          history: "mdi-history",
          contacts: "mdi-account-group",
        };

        return currencyModule.items
          .filter(group => group.items)
          .map(group => ({
            key: `embed-${group.key}`,
            title: group.title,
            icon: embedIcons[group.key],
            items: this.filterSidebarModuleItems(group.items),
          }))
          .filter(group => group.items.length);
      }

      return modules
        .map((module) => ({ ...module, items: this.filterSidebarModuleItems(module.items) }))
        .filter((module) => module.items.length);
    },
    termsDialogTitle() {
      return this.selectLanguage === "sp"
        ? "Términos y Condiciones"
        : "Terms and Conditions";
    },
    termsDialogMessage() {
      return this.selectLanguage === "sp"
        ? "Antes de continuar, debes aceptar los términos y condiciones vigentes."
        : "Before continuing, you must accept the current terms and conditions.";
    },
    termsAcceptLabel() {
      return this.selectLanguage === "sp"
        ? "He leído y acepto los términos y condiciones."
        : "I have read and accept the terms and conditions.";
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    // filteredSections() {
    //   return this.sections
    //     .map(section => {
    //       const filteredItems = section.items.filter(item => this.availableIds.includes(item.id));
    //       if (filteredItems.length > 0) {
    //         return { ...section, items: filteredItems };
    //       }
    //       return null;
    //     })
    //     .filter(section => section !== null);
    // },
    filteredSectionsByCategory() {
      return this.sectionsByCategory.map(category => {
        const filteredSections = category.sections
          .map(section => {
            if (section.items) {
              const filteredItems = section.items.filter(item =>
                this.availableIds.includes(item.id)
              );
              if (filteredItems.length > 0) {
                return { ...section, items: filteredItems };
              }
            } else if (this.availableIds.includes(section.id)) {
              return section;
            }
            return null;
          })
          .filter(Boolean);

        if (filteredSections.length > 0) {
          return {
            ...category,
            sections: filteredSections,
          };
        }

        return null;
      }).filter(Boolean);
    }
  },
  watch: {
    '$store.state.sToken'() { refreshAiAccess(); },
    '$store.state.sEnterpriseId'() { refreshAiAccess(); },
    selectLanguage() {
      if (this.selectLanguage) {
        this.texts = { ...FILE.takeRate[this.selectLanguage], menu: FILE.menu[this.selectLanguage].menu };
      }
    },
  },
};
</script>

<style>
.embed-brand {
  min-height: 150px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.embed-brand__name {
  color: #ffffff;
  font-family: "montserrat-bold";
  font-size: 24px;
  text-align: center;
}

.embed-brand__powered {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
}

/* .v-list-item--active {
  color: yellow !important;
  background-color: yellow !important;
} */

.custom-bold {
  font-family: "montserrat-bold";
  font-weight: bold;
  font-size: medium;
  color: #000;
}

.v-dialog {
  border-radius: 25px !important;
}
.active-section .v-list-item__title {
  background-color: yellow !important;
}

.active-item {
  background-color: #f5f7f9 !important;
}

.v-list-item__content {
  font-family: "montserrat-semibold";
}

.activeGroup {
  border-left: 8px white solid;
  border-radius: 5px;
  margin-left: -8px;
  color: #ffffff !important;
  background-color: #0e284d;
}
.activeItem {
  border-radius: 5px;
  color: #ffffff !important;
  background-color: var(--embed-accent-color);
}
.button-select-language {
  width: 100%;
  height: 40px !important;
  background-color: transparent !important;
  border-radius: 10px;
  opacity: 1;
  color: #ffffff !important;
  font-size: 14px !important;
  text-transform: capitalize;
  justify-content: flex-start;
}

.button-select-language-active {
  width: 100%;
  height: 40px !important;
  background: #163969 0% 0% no-repeat padding-box !important;
  border-radius: 10px;
  opacity: 1;
  color: #ffffff !important;
  font-size: 14px !important;
  text-transform: capitalize;
  justify-content: flex-start;
}

.button-session {
  background-color: transparent !important;
  height: 70px !important;
  width: 100% !important;
  border-radius: 0px;
  color: #ffffff !important;
  font-size: 16px;
  text-transform: initial;
  justify-content: flex-start;
  padding-left: 40px !important;
}

.text-wrap {
  white-space: normal;
  word-wrap: break-word;
}

.sidebar-menu {
  padding-top: 10px;
}

.sidebar-module {
  margin: 7px 0;
  font-family: "montserrat-semibold";
}

.sidebar-module__header,
.sidebar-submodule__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 0;
  color: #ffffff;
  cursor: pointer;
  font-family: "montserrat-semibold";
  letter-spacing: 0;
}

.sidebar-module__header {
  min-height: 35px;
  padding: 0 14px;
  border-radius: 8px;
  background: transparent;
  font-size: 15px;
  transition: background 0.2s ease;
}

.sidebar-module__header:hover {
  background: rgba(14, 40, 77, 0.72);
}

.sidebar-module__title,
.sidebar-module__actions,
.sidebar-submodule__title {
  display: flex;
  align-items: center;
}

.sidebar-module__title {
  min-width: 0;
  gap: 13px;
}

.sidebar-module__title span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-module__actions {
  flex: 0 0 auto;
  gap: 8px;
}

.sidebar-module__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
  padding: 0 6px;
  border-radius: 5px;
  background: var(--embed-accent-color);
  color: #ffffff;
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
}

.sidebar-module__body {
  position: relative;
  margin: 0px 0 10px 24px;
  padding: 0px 0 2px 12px;
}

.sidebar-module__body::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 2px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.28);
}

.sidebar-submodule {
  margin: 3px 0;
}

.sidebar-submodule__header {
  min-height: 35px;
  padding: 0 12px;
  border-radius: 8px;
  background: transparent;
  font-size: 13px;
  transition: background 0.2s ease;
}

.sidebar-submodule__header:hover {
  background: rgba(255, 255, 255, 0.08);
}

.sidebar-submodule__title {
  min-width: 0;
  gap: 10px;
}

.sidebar-submodule__items {
  position: relative;
  margin-left: 10px;
  padding: 4px 0 4px 16px;
}

.sidebar-submodule__items::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 2px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
}

.sidebar-menu-item {
  min-height: 42px !important;
  margin: 3px 0;
  padding: 0 12px !important;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.84) !important;
}

.sidebar-menu-item--nested {
  min-height: 38px !important;
}

.sidebar-menu-item .v-list-item__icon {
  min-width: 30px;
  margin: 0 9px 0 0 !important;
  align-self: center;
}

.sidebar-menu-item .v-list-item__content {
  padding: 6px 0;
}

.sidebar-menu-item .v-list-item__title {
  color: rgba(255, 255, 255, 0.86);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  white-space: normal;
}

.sidebar-menu-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.sidebar-menu-item.activeItem .v-list-item__title,
.sidebar-menu-item.activeItem .v-icon {
  color: #ffffff !important;
}

.v-navigation-drawer {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
  margin: 8px;
  height: calc(100vh - 16px) !important;

}
#inspire > div > nav > div.v-navigation-drawer__content > div > div:nth-child(1) > div.v-list.mx-5.v-sheet.theme--dark > div:nth-child(2) > div > div.v-list-item__icon.v-list-group__header__append-icon {
  min-width: 0px;
}
#inspire > div > nav > div.v-navigation-drawer__content > div > div:nth-child(1) > div.v-list.mx-5.v-sheet.theme--dark > div:nth-child(3) > div > div.v-list-item__icon.v-list-group__header__append-icon {
  min-width: 0px;
}
.theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
  opacity: 0 !important;
}
</style>
